var map = {
	"./avatar-bonnie-base-full.png": 95515,
	"./avatar-bonnie-dino-full.png": 19064,
	"./avatar-bonnie-fall-full.png": 9584,
	"./avatar-bonnie-smoothie-full.png": 17168,
	"./avatar-bonnie-space-full.png": 94085,
	"./avatar-bonnie-spring-full.png": 79489,
	"./avatar-bonnie-summer-full.png": 7933,
	"./avatar-bonnie-winter-full.png": 84325
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74907;